import gql from 'graphql-tag';

import embeddedDokkioTagFragment from './embeddedDokkioTagFragment';
import dokkioObjectDokkioTagFragment from './dokkioObjectDokkioTagFragment';
import taskFragment from './taskFragment';

export const webpageFragment = gql`
  fragment webpageFragment on Webpage {
    accountID
    dokkioClass
    id
    name
    url
    lastViewedAt
    clippedAt
    hasThumbnail
    htmlSavedAt
    rowCreatedAt
    dokkioTags {
      ...embeddedDokkioTagFragment
    }
    dokkioObjectDokkioTags {
      ...dokkioObjectDokkioTagFragment
    }
    dokkioTagIDs
    summary
    tasks {
      ...taskFragment
    }
  }
  ${dokkioObjectDokkioTagFragment}
  ${embeddedDokkioTagFragment}
  ${taskFragment}
`;
export default webpageFragment;
